export default {
  _comment: 'Program Model V1a',
  hash: 'anExampleHashGeneratedByTripianAPI',
  api_key: '7cq5PBc7Qd2dKkbkTP7Gj3uecDODPtof8CZ3pLNZa',
  params: {
    arrival_datetime: '2021-11-28T09:00:00Z',
    departure_datetime: '2021-11-28T18:00:00Z',
    cg_id: 12,
    do_not_generate: 0,
  },
  config: {
    _comment: 'If not provided default values will be used instead. This is for testing purposes.',
    step_config: {
      _comment: '{effect}{actual_value}/{sensitivity}/100*{weight}',
      distance: {
        weight: 300,
        sensitivity: 40,
        effect: '-',
      },
      keyword: {
        weight: 1500,
        sensitivity: 0.04,
        effect: '+',
      },
      rating: {
        weight: 10,
        sensitivity: 0.05,
        effect: '+',
      },
      popularity: {
        weight: 20,
        sensitivity: 50,
        effect: '+',
      },
    },
    answers_config: [
      {
        id: 1,
        keywords: [
          {
            id: 670,
            category_ids: [1, 25, 28, 29],
          },
          {
            id: 10858,
            category_ids: [3, 24, 33],
          },
        ],
      },
      {
        id: 2,
        keywords: [
          {
            id: 999,
            category_ids: [22, 33],
          },
          {
            id: 888,
            category_ids: [55, 66],
          },
        ],
      },
    ],
  },
  days: {
    d20211128: {
      _comment: 'Day Model',
      id: 1,
      generated_status: -1,
      params: {
        city_id: 108,
        start_time: '09:00',
        end_time: '18:00',
        companion_ids: [1, 3, 4],
        adult_no: 4,
        child_no: 1,
        age_avg: 35,
        answers: [16, 5, 18, 6, 12, 34, 24, 25, 26],
        accommodation: {
          ref_id: 'string',
          name: 'string',
          address: 'string',
          coordinate: {
            lat: 43.653226,
            lng: -79.38318429999998,
          },
        },
      },
      steps: [
        {
          _comment: 'steps model',
          id: 1,
          timeframe: [900, 1000],
          poi_types: [33, 24],
          order: 1,
          score: null,
          poi: null,
          alternatives: [],
          step_config: {
            _comment: 'This attibute is not mandatory but any configuration provided here will override other values just for this step',
            distance: {
              weight: 30000,
            },
          },
        },
        {
          _comment: 'steps model',
          id: 2,
          timeframe: [1000, 1130],
          poi_types: [1, 8, 25, 26, 28, 29, 30, 32, 34],
          order: 2,
          score: null,
          poi: null,
          alternatives: [],
          config: {
            _comment: 'This attibute is not mandatory but any configuration provided here will override other values just for this step',
          },
        },
        {
          _comment: 'steps model',
          id: 3,
          timeframe: [1130, 1230],
          poi_types: [1, 8, 25, 26, 28, 29, 30, 32, 34],
          order: 3,
          score: null,
          poi: null,
          alternatives: [],
        },
        {
          _comment: 'steps model',
          id: 4,
          timeframe: [1230, 1330],
          poi_types: [3],
          order: 4,
          score: null,
          poi: null,
          alternatives: [],
        },
        {
          _comment: 'steps model',
          id: 5,
          timeframe: [1330, 1530],
          poi_types: [1, 8, 25, 26, 28, 29, 30, 32, 34],
          order: 5,
          score: 70,
          poi: null,
          alternatives: [],
        },
        {
          _comment: 'steps model',
          id: 6,
          timeframe: [1530, 1730],
          poi_types: [1, 8, 25, 26, 28, 29, 30, 32, 34],
          order: 6,
          score: null,
          poi: null,
          alternatives: [],
        },
        {
          _comment: 'steps model',
          id: 7,
          timeframe: [1730, 2000],
          poi_types: [3],
          order: 7,
          score: null,
          poi: null,
          alternatives: [],
        },
        {
          _comment: 'steps model',
          id: 8,
          timeframe: [2000, 2400],
          poi_types: [31, 35, 4],
          order: 8,
          score: null,
          poi: null,
          alternatives: [],
        },
      ],
      config: {
        config: {
          _comment: 'This attibute is not mandatory but any configuration provided here will override other values just for this day unless it is provided again in a step',
          popularityTotal: 400,
        },
      },
    },
  },
};
